<template>
  <div class="m_t30">
    <!-- <div class="app-img tc">{{ title }}</div> -->
    <!-- <div class="app-title tc">{{ CONFIG.CNTITLE }}</div> -->
    <div class="app-content main-width">
      <div class="policy">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: 1,
    };
  },
  watch() {
    $route: {
      handler: (val, oldVal) => {
        console.log(val, oldVal);
      };
    }
  },
  created() {
    console.log(this.$route, this.params, 876545678);
    switch (this.$route.path) {
      case "/pcm/expendpolicy_a":
        this.title = "研发费用加计扣除";
        break;
      case "/pcm/expendpolicy_b":
        this.title = "研发费用加计扣除";
        break;
      case "/pcm/expendpolicy_c":
        this.title = "研发费用加计扣除";
        break;
      case "/pcm/expendpolicy_d":
        this.title = "研发费用加计扣除";
        break;
      case "/pcm/expendpolicy_e":
        this.title = "研发费用加计扣除";
        break;
      case "/pcm/expendpolicy_f":
        this.title = "研发费用加计扣除";
        break;
      case "/pcm/GHpolicy_a":
        this.title = "高新技术企业认定诊断工具";
        break;
      case "/pcm/GHpolicy_b":
        this.title = "高新技术企业认定诊断工具";
        break;
      case "/pcm/verify":
        this.title = this.$route.query.name ? this.$route.query.name : "";
        break;
      case "/pcm/productSale":
        this.title = "研发费用加计扣除";
        break;
      case "/pcm/tax":
        this.title = "重点软件企业诊断工具";
        break;
      default:
        this.title = "请联系开发设置标题";
        break;
    }
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.app-img {
  position: relative;
  //   height: 220px;
  //   padding-left: 60px;
  width: 100%;
  //   background-image: url("~@/assets/images/bg/apply.png");
  //   background-size: 100% 100%;
  font-size: 30px;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 65px;
}
.app-title {
  color: $white;
  margin-bottom: 30px;
  font-size: 36px;
}
.app-content {
  box-sizing: border-box;
  background: $white;
  z-index: 999;
  padding: 20px 100px 50px;
  margin-bottom: 30px;
}
</style>
<style lang="scss" scoped>
.policy .main-title {
  font-weight: 600;
  font-size: 20px;
  text-align: center;
  color: #cbb486;
  line-height: 55px;
  background: #fff;
  border-bottom: 1px solid #e5e5e5;
}
.policy .clearfix {
  background: #fff;
  padding: 10px;
}
.policy .detail-content {
  border-top: 1px solid #eee;
  background: #f6f6f6 !important;
  padding: 30px 20px 50px;
  line-height: 28px;
  color: #333;
  font-size: 16px;
  letter-spacing: 1px;
}
</style>